export { normalizeWarehouses } from './normalizeWarehouses';
